<template>
  <div>
    <util-tab-title
      title="Pencatatan Terakhir"
      action="/downtime/list"
    ></util-tab-title>
    <util-chart :chartdata="chart"></util-chart>

    <util-add action="/downtime/add" v-if="group == 'Operator Maintenance' || group == 'Operator Project'"></util-add>
    <util-item-downtime
      @select="onItemSelect"
      :listdata="list"
    ></util-item-downtime>

    <div class="item-action" :class="action !== null ? '' : 'hides'">
      <div class="backdrop" @click="action = null"></div>
      <div class="bottom-panel">
        <img
          src="@/assets/img/filter-close.svg"
          alt=""
          class="close"
          @click="action = null"
        />
        <div class="action" @click="goto('view')" v-show="status == 'close' || group == 'Supervisor'">
          <img src="@/assets/img/task-view.svg" alt="" />
          <span>Lihat Detail</span>
        </div>
        <div class="action" @click="goto('task')" v-show="status != 'close' && group != 'Supervisor'">
          <img src="@/assets/img/task.svg" alt="" />
          <span>Kerjakan</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import UtilChart from "@/views/pages/Utilities/Components/Util-Chart.vue";
import UtilTabTitle from "@/views/pages/Utilities/Components/Util-Tab-Title.vue";
import UtilItemDowntime from "@/views/pages/Utilities/Components/Util-Item-Downtime.vue";
import UtilAdd from "@/views/pages/Utilities/Components/Util-Add.vue";
import { api } from "@/api/api.js";
import { UserModule } from "@/store/modules/user";

@Component({
    components: {
      UtilChart,
      UtilTabTitle,
      UtilAdd,
      UtilItemDowntime
    },
})
export default class UtilitiesDowntime extends Vue {
  action = null
  status = null
    onItemSelect(item) {
      this.action = item.id
      this.status = item.status
    }
    goto(type){
      this.$router.push({ path: "/downtime/"+type+"/"+this.action })
      this.action = null
    }

  list = [];
  chart = {series:[],labels:[]};
  mounted(){
    api('downtime_list').then(res => {
      this.list = res.data.data.map(e=>{
        e.date = new Date(e.usage_date);
        return e
      })
    })
    api('downtime_chart').then(res => {
      let data = res.data
      this.chart.series = data.map(e=>Number(`${e.value}`))
      this.chart.labels = data.map(e=>e.tgl)
    })
  }
  group = UserModule.userDetail.accessgroup['name'];
}
</script>
